import { render } from "./UsuarioView.vue?vue&type=template&id=f6b5cde6"
import script from "./UsuarioView.vue?vue&type=script&lang=js"
export * from "./UsuarioView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__